import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from '../../../admin/redux/store'
import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { LoadBalancerGroupGetAllPagedApiArg, useLoadBalancerGroupDeleteMutation } from '../../redux/api/web-api'
import { notifyError, notifySuccess } from '../../features/notificationsManager/Notify'
import { LoadbalancerTableListWidget } from '../../../support/components/loadbalancer-table-list-widget'
import { useCompanyQuery, useLoadbalancerGroupsQuery } from '../../hooks/useFetchEndpoints'
import useText from '../../hooks/useText'

export const defaultFilter: LoadBalancerGroupGetAllPagedApiArg = {
    id: '',
    name: '',
    CompanyName: '',
    page: 0,
    noOfItems: 20,
}

export const LoadbalancerPage = React.memo(function LoadbalancerPage(): React.ReactElement {
    const text = useText()
    const [filter, setFilter] = useState<LoadBalancerGroupGetAllPagedApiArg>(defaultFilter)
    const companyId = useSelector((state: RootState) => state.user.selectedCompanyId)
    const partnerId = useSelector((state: RootState) => state.user.partnerId)

    const {
        data: loadBalancerGroups,
        isFetching: groupsLoading,
        refetch: fetchLoadBalancerGroup,
    } = useLoadbalancerGroupsQuery(partnerId, companyId, filter)

    const { data: companies } = useCompanyQuery(partnerId)

    const filterSubmit = (filter: Partial<LoadBalancerGroupGetAllPagedApiArg>) => {
        setFilter({ ...filter, name: filter?.name?.trim(), id: filter?.id?.trim() })
    }

    const [removeLoadBalancerGroup] = useLoadBalancerGroupDeleteMutation()

    const removeLBGroup = async (groupId: number) => {
        if (groupId) {
            if (confirm(text('lblLoadBalancerDelete'))) {
                try {
                    await removeLoadBalancerGroup({ id: groupId }).unwrap()
                    notifySuccess(text('lblLoadBalancerDeleteSuccess'))
                    fetchLoadBalancerGroup()
                } catch (error) {
                    notifyError(text('lblLoadBalancerDeleteError'))
                }
            }
        }
    }

    return (
        <PageLayoutContainer>
            <LoadbalancerTableListWidget
                loadBalancerGroups={loadBalancerGroups}
                companies={companies}
                filter={filter}
                filterSubmit={filterSubmit}
                removeLBGroup={removeLBGroup}
                setFilter={setFilter}
                groupsLoading={groupsLoading}
            />
        </PageLayoutContainer>
    )
})
